import { Injectable } from '@angular/core';
import { registerPlugin } from '@capacitor/core';

import { MappingsItemSettings } from 'src/app/nav-processing/mappings/mappings.model';
import { FaceLandmarkerResult } from '@mediapipe/tasks-vision';
import {
  PeyeCoordinates,
  WatchPeyeResponseCallback,
  WatchPeyeResultsCallback,
} from '../nav-driver/peye/peye.service';
import { Platform } from '@ionic/angular';
import { ListOptions } from '@angular/fire/compat/storage/interfaces';
import { Watch } from '@angular/core/primitives/signals';
import { WatchEyeResultsCallback } from '../nav-driver/rastreador/rastreador.service';

export interface NativePlugin {
  closeEyeTracker(options: { value: string }): Promise<{ value: string }>;
  passCoordinates(
    callback: WatchEyeResultsCallback
  ): Promise<{ value: number }>;
  startEyeTracker(options: { value: string }): Promise<{ value: string }>;
  echo(options: { value: string }): Promise<{ value: string }>;
  startCamera(options: { value: string }): Promise<{ value: string }>;
  startCameraPreview(options: { value: string }): Promise<{ value: string }>;
  stopCamera(options: { value: string }): Promise<{ value: string }>;
  receiveConfig(options: {
    value: Array<MappingsItemSettings>;
  }): Promise<{ value: string }>;
  setCameraState(options: { value: string }): Promise<{ value: string }>;
  nativeResult(options: { value: string }): Promise<{ value: object }>;
  startPeyeTracker(options: { value: string }): Promise<{ value: string }>;
  resultPeyeTracker(): Promise<{ value: PeyeCoordinates }>;
  closePeyeConnection(options: { value: string }): Promise<{ value: string }>;
  streamingPeyeTracker(
    callback: WatchPeyeResultsCallback
  ): Promise<{ value: number }>;
  sendPeyeMessage(options: { value: string }): Promise<{ value: string }>;
  receivePeyeMessage(
    callback: WatchPeyeResponseCallback
  ): Promise<{ value: string }>;
  connectPeye(options: { value: string }): Promise<{ value: string }>;
  startBt(options: { value: string }): Promise<{ value: string }>;
  getNetworkData(options: { value: Array<number> }): Promise<{ value: string }>;
  permissionsStatus(options: { value: string }): Promise<{ value: string }>;
  accsvPermission(options: { value: string }): Promise<{ value: string }>;
  cameraPermission(options: { value: string }): Promise<{ value: string }>;
 // endMessagePeye(options: { value: string }): Promise<{ value: string }>;
  getScanInterval(options: {value: number  }): Promise<{value: number}>;
  getTouchDuration(options: {value: number  }): Promise<{value: number}>;
}

@Injectable({
  providedIn: 'root',
})
export class NativePluginService {

  plugin: NativePlugin;
  registered = false;

  constructor(private plt: Platform) {
    plt.ready().then(() => {
      //console.log('Platform ready InputControlService');
      if (plt.is('capacitor') || plt.is('cordova')) {
        this.registerNativePlugin();
      }
    });
  }

  registerNativePlugin() {
    console.log('Platform ready registerNativePlugin');
    this.plugin = registerPlugin<NativePlugin>('customNative');
    this.registered = true;
  }
}
